<mat-sidenav-container>
  <mat-sidenav #sidenav [opened]="false" mode="over" position="end" class="sidenav mat-elevation-z6">
    <div class="d-flex flex-row flex-wrap">
      <div class="flex-100 text-right">
        <button mat-icon-button [attr.aria-label]="'Close'" class="close" (click)="sidenav.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="flex-100" *ngIf="!loggedIn">
        <a [routerLink]="['/account']" routerLinkActive="router-link-active" name="Register/Login" class="top-items">
          <mat-icon class="mat-icon-lg ml-2 mr-3" fontSet="material-icons-outlined">manage_accounts</mat-icon><span>Register/Login</span>
        </a>
      </div>
      <div *ngIf="loggedIn" class="flex-100 mobile-menu-account">
        <mat-accordion *ngIf="loggedIn">
          <mat-expansion-panel [expanded]="accountPage">
            <mat-expansion-panel-header *ngIf="!customer?.firstName">
              <mat-icon class="mat-icon-lg" fontSet="material-icons-outlined">manage_accounts</mat-icon><span>My Account</span>
            </mat-expansion-panel-header>
            <mat-expansion-panel-header *ngIf="customer?.firstName" class="name">
              <mat-icon class="mat-icon-lg" fontSet="material-icons-outlined">manage_accounts</mat-icon><span>{{customer?.firstName}}</span>
            </mat-expansion-panel-header>
            <div *ngFor="let section of settings.accountLinks" class="account">
              <div *ngIf="!section?.children?.length">
                <a [routerLink]="section.routerLink" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}" class="account-section-title">{{section.name}}</a>
              </div>
              <div *ngIf="section?.children?.length > 0">
                <span class="account-section-title">{{section.name}}</span>
                <mat-list-item *ngFor="let link of section.children">
                  <a matLine [routerLink]="link.routerLink" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">{{ link.name }}</a>
                </mat-list-item>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="flex-100">
        <a *ngIf="customer?.totalCartCount > 0" [routerLink]="['/cart']" routerLinkActive="router-link-active" name="Shopping Cart" class="top-items">
          <mat-icon class="mat-icon-lg ml-2 mr-3" [matBadge]="customer?.totalCartCount" matBadgeSize="medium" matBadgeColor="warn">shopping_cart</mat-icon><span>View Cart</span>
        </a>
        <div *ngIf="!customer || customer?.totalCartCount === 0" name="Shopping Cart" class="top-items">
          <mat-icon class="mat-icon-lg ml-2 mr-3" fontSet="material-icons-outlined">shopping_cart</mat-icon><span>Cart is Empty</span>
        </div>
      </div>
    </div>
    <div class="divider mt-1"></div>
    <ng-container *ngIf="sitemapItems">
      <app-sidenav-menu *ngIf="!settings.megaMobileNav && sitemapItems && sitemapItems?.length > 0" [menuItems]="sitemapItems" [menuParentId]="'root'" [level]="0"></app-sidenav-menu>
      <app-sidenav-mega *ngIf="settings.megaMobileNav && mega?.items && mega?.items.length > 0" [menuItems]="mega?.items" [menuParentId]="'root'" [level]="0"></app-sidenav-mega>
    </ng-container>
  </mat-sidenav>
  <div id="app" class="h-100 app" [ngClass]="settings.theme" [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
    <div class="d-flex flex-row flex-wrap theme-container theme-container-no-overflow">
      <app-header-desktop class="flex-100 d-none d-lg-block" [menuOverflow]="menuOverflow" [menuPosition]="menuPosition" [menuTop]="menuTop" [menuBackground]="menuBackground" [menuLogo]="menuLogo"></app-header-desktop>
      <app-header-mobile class="flex-100 d-lg-none" [inputSideNav]="sidenav" [menuOverflow]="menuOverflow" [menuPosition]="menuPosition" [menuTop]="menuTop" [menuBackground]="menuBackground" [menuLogo]="menuLogo"></app-header-mobile>
    </div>
    <ng-container *ngIf="!isCheckout">
      <div class="theme-container">
        <app-breadcrumb *ngIf="sitemapItems" [breadcrumbItems]="sitemapItems"></app-breadcrumb>
      </div>
    </ng-container>
    <div id="omnial-content" class="theme-container content-start" style="position: relative;">
      <router-outlet></router-outlet>
    </div>
    <ng-container>
      <app-footer></app-footer>
      <div *ngIf="showBackToTop" class="d-flex flex-row back-to-top transition justify-content-center align-items-center" (click)="scrollToTop()">
        <mat-icon>arrow_upward</mat-icon>
      </div>
    </ng-container>
  </div>
</mat-sidenav-container>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.6)" size="medium" color="#d2942f" type="ball-atom" [fullScreen]="true">
  <div class="d-flex flex-row flex-wrap justify-content-center align-items-start">
    <a mat-button color="primary" style="text-transform: uppercase; display: inline-block; margin-top: 10px;">Processing, please wait a moment....</a>
  </div>
  <div class="d-flex flex-row flex-wrap justify-content-center align-items-start" style="margin-top:250px;opacity: 0.6;">
    <div class="flex-auto">
      <button mat-raised-button color="accent" (click)="resetApp()" class="ml-1">
        <mat-icon class="mat-icon-sm">home</mat-icon>
        <div>Reset</div>
      </button>
    </div>
  </div>
</ngx-spinner>
<div class="refresh-remind hide-print" *ngIf="needsRefresh">
  <a mat-raised-button (click)="refreshVersion()">
    An update is available, please click here to refresh
  </a>
</div>
